<template>
  <router-view></router-view>
</template>

<script>
  import showSwalAlert from 'src/util/alerts'
  import store from '@/store'
  export default {
    mounted(){
      var mouseStop = null;
      document.addEventListener('mousemove', () => {
        clearTimeout(mouseStop)
        mouseStop = setTimeout(() => {
          if( this.$route.name != 'Login' && this.$route.name != 'PasswordReset'){
            showSwalAlert(
              'Has durado mucho tiempo inactivo, has sido bloqueado.',
              'warning'
            )
            let data = {
              user: this.$store.state.auth.user.username,
              name: this.$store.state.auth.user.first_name+' '+this.$store.state.auth.user.last_name,
              avatar: this.$store.state.auth.user.avatar,
              active: 0
            }
            localStorage.setItem( 'user', JSON.stringify(data) )        
            localStorage.removeItem('token')            
            this.$router.push('/lock').catch((e)=>{console.log(e)})
          }
        }, 3600000)
      })
    }    
  }
</script>
